import TitleSection from "../components/TitleSection";
import DataPartners from "../components/DataPartners";
import Resources from "../components/Resources";
import data from "../../../datasets/usecases/kyc";
import Recipes from "../components/Recipes";
// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";

export const KYC = () => {
  return (
    <div className="kyc_landing">
      <TitleSection data={data} />
      <Recipes data={data} />
      <DataPartners dataPartners={data.dataPartners} />
      <Resources {...data} />
      {/* <PricingGetStarted /> */}
    </div>
  );
};
